<template>
  <el-container class="container">
    <el-aside width="150px" style="height: 100vh">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="onSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        :router="true"
      >
        <el-menu-item index="/stock-index-list">
          <i class="el-icon-menu"></i>
          <span slot="title">股指条幅</span>
        </el-menu-item>
        <el-menu-item index="/market-list">
          <i class="el-icon-menu"></i>
          <span slot="title">股指列表</span>
        </el-menu-item>
        <el-menu-item index="/stock-ranking">
          <i class="el-icon-menu"></i>
          <span slot="title">个股排行</span>
        </el-menu-item>
        <el-menu-item index="/futures-list">
          <i class="el-icon-menu"></i>
          <span slot="title">期货列表</span>
        </el-menu-item>
        <el-menu-item index="/major-list">
          <i class="el-icon-menu"></i>
          <span slot="title">汇率列表</span>
        </el-menu-item>
        <el-menu-item index="/bonds-list">
          <i class="el-icon-menu"></i>
          <span slot="title">国债列表</span>
        </el-menu-item>
        <el-menu-item index="/economic-indicator">
          <i class="el-icon-menu"></i>
          <span slot="title">经济指标</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main class="flex_between" ref="main" style="align-items: flex-start">
      <div class="left_router" ref="left_router">
        <div style="margin-bottom: 20px">
          <el-switch v-model="lang" active-text="蒙文" inactive-text="英文">
          </el-switch>
        </div>
        <div v-if="activeIndex == '/futures-list'">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="item in tabList"
              :key="item"
              :label="item"
              :name="item"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="activeIndex == '/bonds-list'">
          <el-tabs v-model="activeName2">
            <el-tab-pane
              v-for="item in tabList2"
              :key="item"
              :label="item"
              :name="item"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="activeIndex == '/market-list'">
          <el-tabs v-model="activeName3" @tab-click="handleClick">
            <el-tab-pane
              v-for="item in tabList3"
              :key="item"
              :label="item"
              :name="item"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <!-- <router-view /> -->
        <iframe
          class="iframe"
          style="height: 50vh"
          :src="linkSrc"
          frameborder="0"
        ></iframe>
        <el-link :href="linkSrc" target="_blank">在新页面打开</el-link>
        <div class="url_path">URL地址: {{ orginUrl }}</div>
        <stockListDetailDoc
          v-if="activeIndex == '/stock-index-list'"
          :path="'/product/stock-index-detail'"
          :iframeSrc="linkSrc"
        ></stockListDetailDoc>
        <stockRankingDetailDoc
          v-if="activeIndex == '/stock-ranking'"
          :path="'/product/stock-detail'"
          :iframeSrc="linkSrc"
        ></stockRankingDetailDoc>
        <stockFutureDetailDoc
          v-if="activeIndex == '/futures-list'"
          :path="'/product/stock-detail'"
          :iframeSrc="linkSrc"
        ></stockFutureDetailDoc>
      </div>
      <div v-if="iframeSrc" ref="box" class="iframe_box">
        <div
          class="move_bar"
          @mousedown="onMouseDown"
          @mouseout="onMouseOut"
        ></div>
        <div class="url_path" style="width: 100%; font-size: 12px">
          URL地址: {{ iframeSrc }}
        </div>
        <iframe class="iframe" :src="iframeSrc" frameborder="0"></iframe>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import stockListDetailDoc from "../components/doc/stock-list-detail.vue";
import stockRankingDetailDoc from "../components/doc//stock-rank-detail.vue";
import stockFutureDetailDoc from "../components/doc/stock-futures-detail.vue";
export default {
  components: {
    stockListDetailDoc,
    stockRankingDetailDoc,
    stockFutureDetailDoc,
  },
  data() {
    return {
      lang: true,
      activeIndex: "/stock-index-list",
      iframeSrc: "",
      obj: {
        offsetX: 0,
        offsetY: 0,
        isMouseDown: false,
      },
      tabList: [],
      activeName: "",
      tabList2: [],
      tabList3: [],
      activeName2: "",
      activeName3: "",
      originPath: "",
    };
  },
  watch: {
    lang(n) {
      if (
        this.activeIndex !== "/bonds-list" &&
        this.activeIndex !== "/economic-indicator"
      ) {
        if (this.iframeSrc) {
          if (!n) {
            this.iframeSrc += "&lang=en";
          } else {
            this.iframeSrc = this.originPath;
          }
        }
      }
    },
    $route: {
      handler(n) {
        this.activeIndex = n.path;
        if (this.activeIndex == "/stock-index-list") {
          // this.iframeSrc = "/product/stock-index-detail";
          this.iframeSrc = "";
        } else if (this.activeIndex == "/stock-ranking") {
          // this.iframeSrc = "/product/stock-detail";
        } else if (this.activeIndex == "/futures-list") {
          // this.iframeSrc = "/product/futures-detail";
        } else {
          this.iframeSrc = "";
        }
        this.iframeSrc = "";
      },
      immediate: true,
    },
  },
  computed: {
    linkSrc() {
      if (this.activeIndex == "/futures-list") {
        return (
          "/product" +
          this.activeIndex +
          "?tabType=" +
          encodeURIComponent(this.activeName || "Energy Futures") +
          "&lang=" +
          (this.lang ? "" : "en")
        );
      }
      if (this.activeIndex == "/market-list") {
        return (
          "/product" +
          this.activeIndex +
          "?tabType=" +
          encodeURIComponent(this.activeName3 || "Energy Futures") +
          "&lang=" +
          (this.lang ? "" : "en")
        );
      }
      if (this.activeIndex == "/bonds-list") {
        return (
          "/product" +
          this.activeIndex +
          "?type=" +
          encodeURIComponent(this.activeName2 || "China") +
          "&lang=" +
          (this.lang ? "" : "en")
        );
      }
      return "/product" + this.activeIndex + "?lang=" + (this.lang ? "" : "en");
    },
    orginUrl() {
      if (this.activeIndex == "/futures-list") {
        return (
          window.location.origin +
          ("/product" +
            this.activeIndex +
            "?tabType=" +
            encodeURIComponent(this.activeName || "Energy Futures"))
        );
      }
      if (this.activeIndex == "/market-list") {
        return (
          window.location.origin +
          ("/product" +
            this.activeIndex +
            "?tabType=" +
            encodeURIComponent(this.activeName3 || "Energy Futures"))
        );
      }
      if (this.activeIndex == "/bonds-list") {
        return (
          window.location.origin +
          ("/product" +
            this.activeIndex +
            "?type=" +
            encodeURIComponent(this.activeName2 || "China"))
        );
      }
      return window.location.origin + "/product" + this.activeIndex;
    },
    link() {
      return window.location.origin + this.iframeSrc;
    },
    code() {
      let path = this.iframeSrc;
      return `let id = getQuery('id')
              let iframeSrc = \`${window.location.origin}${path}?id=\$\{id\}\`
              let queryIframe = document.querySelector('iframe')
              queryIframe.setAttribute('src',iframeSrc) `;
    },
  },
  mounted() {
    window.addEventListener("message", this.getMessageData);
    this.getTabList();
    this.getTabList2();
    this.getTabList3();
  },
  methods: {
    handleOpen(index) {
      console.log(index);
    },
    onSelect(index) {
      if (index == "/stock-index-list") {
        this.iframeSrc = "/product/stock-index-detail";
      } else if (index == "/stock-ranking") {
        this.iframeSrc = "/product/stock-detail";
      } else if (index == "/futures-list") {
        this.iframeSrc = "/product/futures-detail";
      } else {
        this.iframeSrc = "";
      }
    },
    handleClose() {},
    onMouseDown(e) {
      let { obj } = this;
      obj.offsetX = e.offsetX;
      obj.offsetY = e.offsetY;
      obj.isMouseDown = true;
      document.onmousemove = this.mouseMove.bind(this);
      document.onmouseup = this.mouseUp.bind(this);
    },
    mouseMove(e) {
      let main = this.$refs.main.$el;
      let mainWidth = main.offsetWidth;
      console.log(mainWidth);
      let { obj } = this;
      let { isMouseDown, offsetX, offsetY } = obj;
      //   console.log(e.clientX, offsetX);
      let box = this.$refs.box;
      if (isMouseDown) {
        let [x2, y2] = [e.clientX, e.clientY - offsetY];

        let [x1, y1] = [0, box.offsetHeight];
        let x = x2 + x1 - 150;
        let per = 1 - x / mainWidth;

        let maxX = mainWidth - box.offsetWidth;

        let y = window.innerHeight - (y2 + y1);
        console.log(per * 100);
        box.style = `width:${per * 100 + "%"}`;
        this.$refs.left_router.style = `width:${(x / mainWidth) * 100 + "%"}`;
        if (x > 0 && x < maxX && y2 > 0 && y > 0) {
          //   box.style.left = x + "px";
          //   box.style.bottom = y + "px";
        }
      }
    },
    onMouseOut() {
      this.mouseUp();
    },
    mouseUp() {
      //@ts-ignore
      document.onmousemove = "";
      //@ts-ignore
      document.onmouseup = "";
      this.obj = { offsetX: 0, offsetY: 0, isMouseDown: false };
      console.log(this.obj);
    },
    getMessageData(res) {
      // console.log(res);
      try {
        let data = JSON.parse(res.data);
        let url = data.url; // 返回详情页只要的URL地址
        let id = data.id;
        let type = data.type;
        let path = data.path;
        this.originPath = url;
        if (!this.lang) {
          this.iframeSrc = url + "&lang=" + (this.lang ? "" : "en");
        } else {
          this.iframeSrc = url;
        }

        console.log(data);
      } catch (e) {
        console.log(e);
      }
    },
    getTabList() {
      return this.$tool
        .fetchPost("/api/getCharts3TabList")
        .then((res) => {
          let { code, data } = res;
          if (code == 200) {
            this.tabList = data;
            this.activeName = data[0] || "";
          }
        })
        .catch(() => {
          // this.tabList = [
          //   "Energy Futures",
          //   "METAL FUTURES",
          //   "AGRICULTURE FUTURES",
          //   "LIVESTOCK FUTURES",
          //   "INDEX FUTURES",
          //   "INTEREST RATE FUTURES",
          // ];
          // this.activeName = "US";
          // this.activeName = this.tabList[0] || "";
          // this.loading.close();
        });
    },
    getTabList2() {
      return this.$tool
        .fetchPost("/api/getCharts5TabList")
        .then((res) => {
          let { code, data } = res;
          if (code == 200) {
            this.tabList2 = data;
            this.activeName2 = data[0] || "";
          }
        })
        .catch(() => {
          // this.tabList2 = [
          //   "China",
          //   "United States",
          //   "United Kingdom",
          //   "Hong Kong",
          //   "Japan",
          //   "Singapore",
          //   "Australia",
          //   "Canada",
          //   "New Zealand",
          //   "Germany",
          //   "South Korean",
          // ];
          // this.activeName2 = this.tabList2[0] || "";
          // this.loading.close();
        });
    },
    getTabList3() {
      return this.$tool
        .fetchPost("/api/getCharts3TabList")
        .then((res) => {
          let { code, data } = res;
          if (code == 200) {
            this.tabList3 = data;
            this.activeName3 = data[0] || "";
          }
        })
        .catch(() => {
          // this.tabList = [
          //   "Energy Futures",
          //   "METAL FUTURES",
          //   "AGRICULTURE FUTURES",
          //   "LIVESTOCK FUTURES",
          //   "INDEX FUTURES",
          //   "INTEREST RATE FUTURES",
          // ];
          // this.activeName = "US";
          // this.activeName = this.tabList[0] || "";
          // this.loading.close();
        });
    },
    handleClick({ name }) {
      // console.log(23);
      console.log(name);
      // this.loading = this.$loading();
      // this.getFutureList(name);
    },
  },
  destroyed() {
    window.removeEventListener("message", this.getMessageData);
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
  background-color: #333;
}
.iframe {
  width: 100%;
  height: 90vh;
}
.url_path {
  padding: 10px 0;
  font-size: 16px;
  color: #333;
}
.move_bar {
  position: absolute;
  width: 40px;
  height: 40px;

  //   background-color: red;
  &::after {
    content: "";
    width: 20px;
    height: 100%;
    position: absolute;
    left: -10px;
    top: 0;
    background-color: #b3c0d1;
    border-radius: 10px;
  }
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.iframe_box {
  border-left: 2px solid #333333;
  width: 50%;
  position: relative;
  box-sizing: border-box;
  padding: 0 20px;
}
.left_router {
  padding-right: 20px;
  box-sizing: border-box;
  // width: 50%;
  flex: 1;
}
.code_show {
  font-size: 12px;
  background: #ddd;
  padding: 10px;
  box-sizing: border-box;
}
</style>
